import { baseQueryFactory } from '@squareup/dex-data-shared-base-api';
import { getNextPublicSquareDocsURL } from '@squareup/dex-utils-environment';

const connectDocsApiBaseQuery = baseQueryFactory({
  baseUrl: getNextPublicSquareDocsURL(),
});

export { connectDocsApiBaseQuery };
